const MagistratMandataireStyle = {
  bg: "white",
  borderRadius: "6px",
  flexWrap: "wrap",
  overFlow: "hidden",
  position: "relative",
  width: "100%",
};

const MagistratSideStyle = {
  flexBasis: 380,
  flexGrow: 1,
  minHeight: "320px",
};

const MagistratMainStyle = {
  flexBasis: 0,
  flexGrow: 99999,
  minWidth: 320,
  pt: 5,
  px: 4,
};

const MagistratTitleMandataireStyle = {
  color: "textSecondary",
  fontFamily: "heading",
  fontSize: 0,
  mb: "4px",
};

const MagistratContentMandataireStyle = {
  color: "text",
  fontFamily: "body",
  fontSize: 1,
  fontWeight: "600",
  mb: 4,
};

const MagistratTribunal = {
  color: "text",
  fontFamily: "body",
  fontSize: 1,
  fontWeight: "600",
  mb: "5px",
};

export {
  MagistratMandataireStyle,
  MagistratTitleMandataireStyle,
  MagistratContentMandataireStyle,
  MagistratTribunal,
  MagistratSideStyle,
  MagistratMainStyle,
};
